export default __webpack_public_path__ + "static/media/NI.39632c6d.svg";